import {useEffect} from 'react'
import PropTypes from 'prop-types'

export function SignifydScript({sessionId}) {
    useEffect(() => {
        if (!sessionId) return

        let signifydScript = document.getElementById('sig-api')

        if (signifydScript && signifydScript?.getAttribute('data-order-session-id') !== sessionId) {
            signifydScript.setAttribute('data-order-session-id', sessionId)
        } else {
            signifydScript = document.createElement('script')
            signifydScript.nonce = window.__CSP_NONCE__
            signifydScript.async = true
            signifydScript.type = 'text/javascript'
            signifydScript.id = 'sig-api'
            signifydScript.src = 'https://cdn-scripts.signifyd.com/api/script-tag.js'
            signifydScript.setAttribute('data-order-session-id', sessionId)
            signifydScript.dataset.status = 'loading'

            const handleLoad = () => {
                signifydScript.dataset.status = 'success'
            }

            signifydScript.addEventListener('load', handleLoad)
            document.head.appendChild(signifydScript)
        }
    }, [sessionId])

    return null
}

SignifydScript.propTypes = {
    sessionId: PropTypes.string
}
